export default __webpack_public_path__ + "static/media/gpay-button.1b52fe70.svg";